import { useTranslations } from '@i18n/use-translations';
import { useLogout } from '@refinedev/core';
import { Modal } from 'antd';

export const UserCorruptedModal = () => {
  const t = useTranslations('corruptedUserModal');
  const { mutate: mutateLogout } = useLogout();

  return (
    <Modal
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
      closable={false}
      destroyOnClose
      maskClosable={false}
      open={true}
      title={t('header')}
      onCancel={() => mutateLogout()}
      onOk={() => mutateLogout()}
    >
      <p>{t('message')}</p>
    </Modal>
  );
};
